import { Autocomplete, Button, Card, Checkbox, FormControl, FormLabel, Input, Textarea, Typography } from '@mui/joy';
import React, { useEffect, useState } from 'react'
import { post, Token } from '../../../Script/Session';
import { useNavigate } from 'react-router-dom';

function AktivityCreator() {
    const [veranstaltungsart, setveranstaltungsart] = useState();
    const [title, settitle] = useState("");
    const [beginn, setbeginn] = useState();
    const [ende, setende] = useState();
    const [userlist, setuserlist] = useState();
    const [leiter, setleiter] = useState();
    const [protokollführer, setprotokollführer] = useState();
    const [ort, setort] = useState("");
    const [thema, setthema] = useState("");
    const [gäste, setgäste] = useState("");
    const [veranstalter, setveranstalter] = useState("");
    const [kosten, setkosten] = useState("");
    const [anmeldungerlaubt, setanmeldungerlaubt] = useState(false);
    const [grouplist, setgroupslist] = useState();
    const [anmeldungbeschränkt, setanmeldungbeschränkt] = useState([]);
    const [gruppenanmelden, setgrouppenanmelden] = useState([]);
    const [regionallist, setregionallist] = useState();
    const [selreggruppen, setselreggruppen] = useState([]);
    useEffect(() => {
        let body = {};
        body.token = Token.get();
        body.action = "get";
        let response = post(body, "/regionalgruppen");
        console.log("DEBUG", response);
        setregionallist(JSON.parse(response));
    }, []);
    const navigate = useNavigate();
    function create() {
        let body = {};
        body.token = Token.get();
        body.action = "create";
        body.title = title;
        body.time = beginn;
        body.ende = ende;
        body.leiter = leiter.id;
        body.protokollführer = protokollführer.id;
        body.ort = ort;
        body.thema = thema;
        body.gaste = gäste;
        body.veranstalter = veranstalter;
        body.kosten = kosten;
        body.anmeldung = anmeldungerlaubt;
        body.anmeldungbeschränkt = anmeldungbeschränkt;
        body.angemeldetefunktionen = gruppenanmelden;
        body.angemeldetereggruppen = selreggruppen.map((i) => i.id);
        console.log(body);
        let response = post(body, "/aktivitäten");
        if (response == "LOGOUT") {
            navigate("/");
        }
        navigate("/aktivityviewer/" + JSON.parse(response).id);
    }
    useEffect(() => {
        let body = {};
        body.token = Token.get();
        let response = post(body, "/userlist");
        setuserlist(JSON.parse(response).result);
    }, []);
    useEffect(() => {
        const fetchData = async () => {

            try {
                const body = {
                    token: Token.get(),
                    action: "get",
                };

                const response = await post(body, "/editGroups");

                if (!response) {
                    alert("hat einen Fehler!");
                    return;
                }

                const json = JSON.parse(response);
                setgroupslist(json.values);
                console.log(response);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        // Delay fetch slightly to avoid blocking render

        fetchData();
    }, []);

    return (
        <>
            <Card sx={{ mb: 15 }}>
                <Typography level="title-md">Aktivität erstellen</Typography>
                <Input placeholder='Title' value={title} onChange={(e) => settitle(e.target.value)} />
                <FormControl>
                    <FormLabel>Beginn</FormLabel>
                    <Input
                        type="datetime-local"
                        value={
                            beginn
                                ? new Date(beginn).toISOString().slice(0, 16)
                                : ''
                        }
                        onChange={(e) => {
                            const val = e.target.value;
                            setbeginn(val ? new Date(val).getTime() + 7200000 : null);
                        }}
                    />
                </FormControl>
                <FormControl>
                    <FormLabel>Vorausichtliches Ende</FormLabel>
                    <Input
                        type="datetime-local"
                        value={
                            ende
                                ? new Date(ende).toISOString().slice(0, 16)
                                : ''
                        }
                        onChange={(e) => {
                            const val = e.target.value;
                            setende(val ? new Date(val).getTime() + 7200000 : null);
                        }}
                    />
                </FormControl>
                <FormControl>
                    <FormLabel>Leiter</FormLabel>
                    <Autocomplete value={leiter} options={userlist} getOptionLabel={(i) => i.name} onChange={(e, newv) => setleiter(newv)} />
                </FormControl>
                <FormControl>
                    <FormLabel>Protokollführer</FormLabel>
                    <Autocomplete value={protokollführer} options={userlist} getOptionLabel={(i) => i.name} onChange={(e, newv) => setprotokollführer(newv)} />
                </FormControl>
                <FormControl>
                    <FormLabel>Ort</FormLabel>
                    <Textarea value={ort} onChange={(e) => setort(e.target.value)} minRows={3}>
                    </Textarea>
                </FormControl>
                <FormControl>
                    <FormLabel>Thema</FormLabel>
                    <Textarea value={thema} onChange={(e) => setthema(e.target.value)} minRows={3}>
                    </Textarea>
                </FormControl>
                <FormControl>
                    <FormLabel>Gäste</FormLabel>
                    <Textarea value={gäste} onChange={(e) => setgäste(e.target.value)} minRows={3}>
                    </Textarea>
                </FormControl>
                <FormControl>
                    <FormLabel>Veranstalter</FormLabel>
                    <Input value={veranstalter} onChange={(e) => setveranstalter(e.target.value)} />
                </FormControl>
                <FormControl>
                    <FormLabel>Kosten</FormLabel>
                    <Input value={kosten} onChange={(e) => setkosten(e.target.value)} />
                </FormControl>
                <Checkbox checked={anmeldungerlaubt} onChange={(e) => setanmeldungerlaubt(e.target.checked)} label="Anmeldung erlaubt" />

                {
                    anmeldungerlaubt && (
                        <Card variant='soft' sx={{ mb: 2 }}>
                            <Typography>Anmeldung beschränken auf</Typography>
                            {
                                grouplist && grouplist.map((item) => {
                                    return (
                                        <Checkbox onChange={(e) => {
                                            if (e.target.checked) {
                                                setanmeldungbeschränkt(prev => [...prev, item.name]);
                                            } else {
                                                setanmeldungbeschränkt(prev =>
                                                    prev.filter(name => name !== item.name)
                                                );
                                            }
                                        }} checked={anmeldungbeschränkt.includes(item.name)} label={item.name} />
                                    )
                                })
                            }
                        </Card>
                    )
                }
                <Card variant='soft' sx={{ mb: 2 }}>
                    <Typography>Funktionen anmelden</Typography>
                    {
                        grouplist && grouplist.map((item) => {
                            return (
                                <Checkbox onChange={(e) => {
                                    if (e.target.checked) {
                                        setgrouppenanmelden(prev => [...prev, item.name]);
                                    } else {
                                        setgrouppenanmelden(prev =>
                                            prev.filter(name => name !== item.name)
                                        );
                                    }
                                }} checked={gruppenanmelden.includes(item.name)} label={item.name} />
                            )
                        })
                    }
                </Card>
                <Card variant='soft' sx={{ mb: 2 }}>
                    <Typography>Regionalgruppen anmelden</Typography>
                    {
                        regionallist && regionallist.result.map((item) => {
                            return (
                                <Checkbox
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setselreggruppen(prev => [...prev, item]); 
                                        } else {
                                            setselreggruppen(prev =>
                                                prev.filter(p => p !== item) 
                                            );
                                        }
                                    }}
                                    checked={selreggruppen.includes(item)}
                                    label={item.name}
                                />
                            )

                        })
                    }
                </Card>
                <Button onClick={() => create()}>
                    Erstellen
                </Button>

            </Card>
        </>
    )
}

export default AktivityCreator
